import { FC } from 'react';
import KpiCard from '@/components/admin/KpiCard';
import type { ResumoAgregado } from '@/utils/equiplexSop';
import { fmtBRLCompacto, fmtCompacto, fmtData, fmtDesvio, fmtPct, fmtPreco, fmtUn } from '@/utils/painelFormat';
import LinhaRegua from '../LinhaRegua';

interface Props {
  resumo: ResumoAgregado;
  coberturaBaixa: boolean;
  /** Último dia fechado quando o recorte tem o mês em andamento; `null` quando só tem meses fechados. */
  fechadoAte: string | null;
}

/**
 * Os cinco números do recorte. Todos derivam do resumo mensal que o backend já fechou.
 * Críticos/alertas não têm KPI: o card "Distribuição por faixa" logo abaixo já mostra.
 */
const SopKpis: FC<Props> = ({ resumo, coberturaBaixa, fechadoAte }) => (
  <div className="grid grid-cols-[repeat(auto-fit,minmax(15rem,1fr))] gap-4" data-testid="sop-kpis">
    <KpiCard
      icon="precision_manufacturing"
      value={fmtCompacto(resumo.produzidoBase)}
      label="Produzido das OPs do mês"
      sublabel={`de ${fmtCompacto(resumo.programadoBase)} programadas${fechadoAte ? ` (mês aberto até ${fmtData(fechadoAte).slice(0, 5)})` : ''}`}
    >
      <LinhaRegua>
        Reportado nas OPs que começaram no mês, sem reprocesso: o CP0511 do Datasul sem as OPs 100…, o mesmo produzido da
        Visão geral e do Relatório Daily.
      </LinhaRegua>
    </KpiCard>
    <KpiCard
      icon="target"
      value={fmtDesvio(resumo.desvioPct)}
      label="Desvio de volume"
      sublabel={resumo.aderenciaPct === null ? 'sem programado no recorte' : `aderência de ${fmtPct(resumo.aderenciaPct)}`}
    />
    <KpiCard
      icon="payments"
      value={fmtBRLCompacto(resumo.faturadoValor)}
      label="Faturado"
      sublabel={coberturaBaixa ? 'bem abaixo do normal — veja o aviso' : `${fmtCompacto(resumo.faturadoQtd)} unidades`}
    />
    <KpiCard icon="sell" value={fmtPreco(resumo.pmv)} label="Preço médio" sublabel="faturado ÷ unidades faturadas" />
    <KpiCard
      icon="science"
      value={fmtUn(resumo.lotesPendentesCq)}
      label="Lotes destas OPs no CQ"
      sublabel="só das OPs dos meses escolhidos; a fila inteira está na aba Qualidade"
    />
  </div>
);

export default SopKpis;
